module.exports = __webpack_public_path__ + "img/hover_icon_public_portal_applications.3cf8eaee.svg";